module.exports = __webpack_public_path__ + "img/wide.b6e57fb2.jpg";